/**
 * AuthCallback — retour depuis Emergent Auth (Google).
 *
 * Le fragment de l'URL contient `#session_id=<...>`. Ce composant l'échange
 * côté backend, laisse le back poser le cookie httpOnly `session_token` puis
 * redirige silencieusement vers l'espace de travail (`/aujourdhui`).
 *
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 */
import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { toast } from "sonner";
import { useAuth } from "../contexts/AuthContext";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    // useRef + set synchrone pour bloquer les doubles montages StrictMode.
    if (processed.current) return;
    processed.current = true;

    const hash = location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/connexion", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(match[1]);

    (async () => {
      try {
        await api.authGoogleExchange(sessionId);
        await refresh();
        // On efface le fragment de l'URL avant de rediriger.
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/aujourdhui", { replace: true });
      } catch (err) {
        const msg = err?.response?.data?.detail || "Impossible de finaliser la connexion Google.";
        toast.error(typeof msg === "string" ? msg : "Connexion Google échouée");
        navigate("/connexion", { replace: true });
      }
    })();
  }, [location.hash, navigate, refresh]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F4F5EF]" data-testid="auth-callback">
      <div className="text-center">
        <div className="w-12 h-12 rounded-full border-4 border-[#0B1F33]/20 border-t-[#0B1F33] animate-spin mx-auto" aria-hidden />
        <div className="mt-4 text-[13px] font-semibold text-[#0B1F33]">Connexion à votre espace RentaScan…</div>
      </div>
    </div>
  );
}
